import api from './api';

export interface StylingCompany {
  _id?: string;
  name: string;
  email?: string;
  phone?: string;
  contactName?: string;
  website?: string;
  specialties?: string[];
  pricing?: Record<string, number>;
  isActive?: boolean;
}

export const getStylingCompanies = async (agencySlug: string): Promise<StylingCompany[]> => {
  try {
    const response = await api.get(`/agencies/${agencySlug}/stylers`);
    return response.data || [];
  } catch (error) {
    console.error('Error fetching styling companies:', error);
    return [];
  }
};

export const createStylingCompany = async (agencySlug: string, data: StylingCompany): Promise<StylingCompany> => {
  try {
    const response = await api.post(`/agencies/${agencySlug}/stylers`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating styling company:', error);
    throw error;
  }
};

export const updateStylingCompany = async (agencySlug: string, stylerId: string, data: StylingCompany): Promise<StylingCompany> => {
  try {
    const response = await api.put(`/agencies/${agencySlug}/stylers/${stylerId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating styling company:', error);
    throw error;
  }
};

export const deleteStylingCompany = async (agencySlug: string, stylerId: string): Promise<void> => {
  try {
    await api.delete(`/agencies/${agencySlug}/stylers/${stylerId}`);
  } catch (error) {
    console.error('Error deleting styling company:', error);
    throw error;
  }
}; 